<template>
    <div class="other-condition">
        <h1 class="title">房源政策</h1>
        <div class="group">
            <!-- <div class="title">
                房源政策
            </div> -->
            <div v-if="!policy.length" style="color: #909090;font-size:16px;">
                房東沒有提供
            </div>
            <div class="content">
                <ul>
                    <li v-for="(item, index) in policy" :key="index" v-html="item.split('\n').join('<br>')">
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            policy: 'GET_SHARE_HOUSE_POLICY',
        })
    },
}
</script>
<style lang="scss" scoped>
    .other-condition{
        position: relative;
        width: 100%;
        h1.title{
            margin-bottom: 20px;
            font-size: 28px;
            color: #3a455f;
        }
        .group{
            .title{
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 10px;
            }
            .content{
                position: relative;
                line-height: 1.75;
                font-size: 16px;
                word-break: break-all;
                img{
                    margin-right: 10px;
                }
                ul{
                    li{
                        word-break: break-word;
                        white-space: break-spaces;
                    }
                }
            }
        }
    }
    @media (max-width: 992px) {
        .other-condition{
            h1.title{
                margin-bottom: 16px;
                font-size: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/otherCondition.vue